export const GET_PROJECT_TYPES_PENDING = 'get_project_types_pending';
export const GET_PROJECT_TYPES_SUCCESS = 'get_project_types_success';
export const GET_PROJECT_TYPES_FAILURE = 'get_project_types_failure';
